import { _ as _applyDecoratedDescriptor } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<Input\n  @value={{@value}}\n  @type={{@type}}\n  autocomplete=\'off\'\n  {{did-insert this.onInsert}}\n  ...attributes\n/>\n");

var _class;
let BbFocusInputComponent = (_class = class BbFocusInputComponent extends Component {
  onInsert(element) {
    if (window.innerWidth > 640) {
      element.focus();
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "onInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsert"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbFocusInputComponent);

export { BbFocusInputComponent as default };
//# sourceMappingURL=bb-focus-input.js.map
